"use client";

import AdditionalOption from "@/views/public/floor-plan-designs/AdditionalOption";
import DesignHolder from "@/views/public/floor-plan-designs/design-creator/DesignHolder";
import DesignDescription from "@/views/public/floor-plan-designs/DesignDescription";
import FurnitureOption from "@/views/public/floor-plan-designs/FurnitureOption";
import Head from "@/views/public/floor-plan-designs/Head";
import Hero from "@/views/public/floor-plan-designs/Hero";
import IndividualOption from "@/views/public/floor-plan-designs/IndividualOption";
import KitchenOption from "@/views/public/floor-plan-designs/KitchenOption";
import { useTranslations } from "next-intl";

export default function FloorPlanDesignsContent() {
  const t = useTranslations("floorPlanDesigns");
  return (
    <>
      <Head />
      <p className="gs--page-column text-ring pt-8 text-center">
        {t("head.description")}
      </p>
      <DesignHolder />
      <FurnitureOption />
      <KitchenOption />
      <AdditionalOption />
      <DesignDescription />
      <IndividualOption />
      <Hero />
    </>
  );
}
